'use client';

import * as React from 'react';
import { User } from '@alien-platform/bo-sdk-v2';
import { Accordion, AccordionDetails, AccordionSummary, Button, CircularProgress, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import { CaretDown } from '@phosphor-icons/react/dist/ssr/CaretDown';

import { GeneralDrawer, ModalDrawer } from '@/types/general';
import { ModalButton } from '@/components/core/modal-button';

import { StaffDetailsTable } from './staff-details-table';

export function DetailsTab({ userData }: { userData: User | null }): React.JSX.Element {
  return (
    <Stack direction="column">
      {!userData ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
          <CircularProgress color="primary" size={38} />
        </Box>
      ) : (
        <Stack gap={2}>
          <StaffDetailsTable userData={userData} />
          <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<CaretDown />} aria-controls="panel1-content" id="panel1-header">
              <Typography component="span">User Actions</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Stack direction="row" gap={2}>
                <Box>
                  <Button variant="contained" color="info" size="small">
                    Change Role
                  </Button>
                </Box>
                <Box>
                  <ModalButton
                    text="Change Password"
                    color="warning"
                    modal={ModalDrawer.CHANGE_PASSWORD}
                    content={userData}
                    size="small"
                  />
                </Box>
                <Box>
                  <ModalButton
                    text={userData.isBlocked ? 'Unblock User' : 'Block User'}
                    color="secondary"
                    modal={ModalDrawer.BLOCK_USER}
                    content={userData}
                    size="small"
                  />
                </Box>
              </Stack>
            </AccordionDetails>
          </Accordion>
        </Stack>
      )}
    </Stack>
  );
}
